/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsWiseSummary {
    getFixupPrototypeFunction() { return SavingsWiseSummary.fixupPrototype; }

    static newInstance(model: Partial<SavingsWiseSummary>): SavingsWiseSummary {
        let obj = Object.assign(new SavingsWiseSummary(), model);
        SavingsWiseSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsWiseSummary>): SavingsWiseSummary {
        if (!model) return null;
        return SavingsWiseSummary.newInstance(<SavingsWiseSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsWiseSummary) {
        if (!obj) return;

        models.SavingsWiseSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsWiseSummary): boolean {
        Object.setPrototypeOf(obj, SavingsWiseSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_saved_till_date) {
            for (let val of this.cost_saved_till_date) {
                models.CostWiseSummary.fixupPrototype(val);
            }
        }
        if (this.cost_saved_current_month) {
            for (let val of this.cost_saved_current_month) {
                models.CostWiseSummary.fixupPrototype(val);
            }
        }
        if (this.potential_cost_saving_recommended) {
            for (let val of this.potential_cost_saving_recommended) {
                models.CostWiseSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Details about cost saved till date
     */
    cost_saved_till_date: Array<models.CostWiseSummary>;

    /**
     * Cost saved for the current month
     */
    cost_saved_current_month: Array<models.CostWiseSummary>;

    /**
     * recommendations on cost savings
     */
    potential_cost_saving_recommended: Array<models.CostWiseSummary>;

}
